import { Link } from "react-router-dom";
import { LegalDoc, Section, Bullets } from "@/components/LegalDoc";
import { useSeo } from "@/lib/seo";

export default function CookiePolicy() {
  useSeo({
    title: "Cookie Policy — StayGuide",
    description: "Come StayGuide utilizza i cookie e le tecnologie simili, e come gestire le tue preferenze.",
    path: "/cookie",
  });
  const openCookie = () => window.dispatchEvent(new Event("open-cookie-settings"));
  return (
    <LegalDoc
      title="Cookie Policy"
      updated="Giugno 2026"
      intro="Questa policy spiega come StayGuide utilizza i cookie e le tecnologie simili.">
      <Section n="1" title="Cosa sono i cookie">
        <p>I cookie sono piccoli file di testo memorizzati sul tuo dispositivo che consentono al sito di funzionare correttamente e di ricordare alcune informazioni.</p>
      </Section>
      <Section n="2" title="Cookie tecnici e necessari">
        <p>Utilizziamo cookie e tecnologie di archiviazione strettamente necessari, che non richiedono consenso:</p>
        <Bullets items={[
          "sg_token — mantiene la tua sessione di accesso come host.",
          "sg_cookie_consent — memorizza la tua scelta relativa ai cookie.",
        ]} />
      </Section>
      <Section n="3" title="Cookie di terze parti">
        <p>Alcuni servizi che utilizziamo possono impostare cookie propri, ad esempio Stripe per l'elaborazione sicura dei pagamenti e la prevenzione delle frodi. Tali cookie sono regolati dalle rispettive informative dei fornitori.</p>
      </Section>
      <Section n="4" title="Cookie di profilazione e marketing">
        <p>Attualmente non utilizziamo cookie di profilazione o di marketing. In caso di introduzione futura, richiederemo il tuo consenso esplicito.</p>
      </Section>
      <Section n="5" title="Gestione del consenso">
        <p>Al primo accesso mostriamo un banner per raccogliere la tua scelta. Puoi modificare le preferenze in qualsiasi momento tramite il pulsante seguente o dal footer del sito.</p>
        <button onClick={openCookie} data-testid="cookie-page-manage" className="inline-flex items-center rounded-full bg-blue-500 text-white font-semibold px-5 py-2.5 hover:bg-blue-600 transition-colors">Gestisci le preferenze cookie</button>
      </Section>
      <Section n="6" title="Contatti">
        <p>Per informazioni sui cookie scrivi a <a href="mailto:privacy@stayguide.it" className="text-blue-600 font-semibold">privacy@stayguide.it</a>. Consulta anche la nostra <Link to="/privacy" className="text-blue-600 font-semibold">Privacy Policy</Link>.</p>
      </Section>
    </LegalDoc>
  );
}
